module.exports = __webpack_public_path__ + "static/media/pic2.2e988d68.jpg";